import axios from 'axios';

export default async function fetchFromBackend<T>(path: string): Promise<T> {
  const backendUrl = 'https://api.tanzcentrum-ettlingen.de';
  const response = await axios.get(`${backendUrl}/${path}`);
  return await response.data;
}
